import { useState, useEffect } from "react";

const SelectDate = ({
	available,
	today,
	setToday,
	hour,
	setHour,
	setShowSelectDate,
	hourList,
	setHourList,
}) => {
	const [appointment, setAppointment] = useState(new Date());

	useEffect(() => {
		if (today && hour) {
			setAppointment(new Date(`${today} ${hour}`));
		}
	}, [today, hour]);

	return (
		<>
			<div className="tour-type">In-person</div>
			<div className="tour-prefered">Select a preferred time</div>
			<div className="tour-date-wrap">
				<select
					className="select-input"
					value={today}
					onChange={(e) => {
						const nextDay = e.target.value;
						setToday(nextDay);
						setHourList(available[nextDay] || []);
						setHour((available[nextDay] || [])[0] || "");
					}}
				>
					{Object.keys(available).map((day) => (
						<option value={day} key={day}>
							{day}
						</option>
					))}
				</select>
			</div>
			<div>
				<select
					className="select-input"
					value={hour}
					onChange={(e) => {
						setHour(e.target.value);
					}}
				>
					{hourList.map((hour) => (
						<option value={hour} key={hour}>
							{hour}
						</option>
					))}
				</select>
			</div>

			<button type="button" className="btn btn-w" onClick={() => setShowSelectDate(false)}>
				<div className="btn-desc">
					{appointment.toDateString()} at {appointment.toLocaleTimeString()}
				</div>
				<div>Request this time</div>
			</button>
		</>
	);
};

export default SelectDate;
